import type { BasketSnapshot } from "../lib/basketTransfer.js";
import { CloseIcon } from "./Icons.js";

interface BasketImportDialogProps {
  snapshot: BasketSnapshot;
  source: "file" | "link";
  onImport: () => void;
  onCancel: () => void;
}

export function BasketImportDialog({
  snapshot,
  source,
  onImport,
  onCancel,
}: BasketImportDialogProps) {
  const symbols = [
    ...new Set(snapshot.cards.map((card) => card.symbol.toUpperCase())),
  ];

  return (
    <div
      className="basket-import-overlay"
      role="presentation"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onCancel();
      }}
    >
      <section
        className="basket-import-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="basket-import-title"
      >
        <header className="basket-import-dialog__header">
          <div>
            <span className="basket-import-dialog__eyebrow">
              {source === "link" ? "Shared basket" : "Basket file"}
            </span>
            <h2 id="basket-import-title">{snapshot.name}</h2>
          </div>
          <button
            type="button"
            className="icon-button"
            onClick={onCancel}
            aria-label="Close basket preview"
          >
            <CloseIcon />
          </button>
        </header>

        <div className="basket-import-dialog__body">
          <div className="basket-import-dialog__summary">
            <strong>
              {snapshot.cards.length}{" "}
              {snapshot.cards.length === 1 ? "chart" : "charts"}
            </strong>
            <span>
              Includes chart ranges, styles, volume settings, and layout.
            </span>
          </div>
          {symbols.length > 0 && (
            <div className="basket-import-dialog__symbols">
              {symbols.map((symbol) => (
                <span key={symbol}>{symbol}</span>
              ))}
            </div>
          )}
        </div>

        <footer className="basket-import-dialog__footer">
          <button
            type="button"
            className="button button--secondary"
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            type="button"
            className="button button--primary"
            onClick={onImport}
          >
            Add as new basket
          </button>
        </footer>
      </section>
    </div>
  );
}
